module.exports = __webpack_public_path__ + "static/media/fam-show.8d9c7ef5.png";